export default __webpack_public_path__ + "static/media/slide11.d9f07088.svg";